export default __webpack_public_path__ + "static/media/F0004.29fe7b8a.png";